import { useState, useContext } from 'react';
import { login } from '../../api/auth';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import Swal from 'sweetalert2';
import '../../styles/login.css';

function Login() {
  const [formData, setFormData] = useState({ emailId: '', password: '' });
  const { login: loginUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect target after login (from ProtectedRoute or default to '/')
  const from = location.state?.from?.pathname || '/';

  // Handle input changes
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await login(formData);

      // Log in the user and store token
      loginUser(data.user, data.token);

      Swal.fire({
        icon: 'success',
        title: 'Login Successful',
        timer: 1500,
        showConfirmButton: false,
      });

      navigate(from, { replace: true });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: error.response?.data?.message || 'Something went wrong. Please try again.',
      });
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="emailId"
          placeholder="Email"
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          onChange={handleChange}
          required
        />
        <button type="submit">Login</button>
      </form>

      <p className="redirect-text">
        Not registered?{' '}
        <Link to="/register" className="register-link">
          Register here
        </Link>
      </p>
      <p className="redirect-text">
  <Link to="/forgot-password" className="forgot-link">
    Forgot password?
  </Link>
</p>

    </div>
  );
}

export default Login;
